module.exports = __webpack_public_path__ + "img/md-dark-indigo.9ed6e4ba.svg";